import { Node } from 'prosemirror-to-html-js';

export default class HorizontalRule extends Node {
  matching() {
    return this.node.type === "horizontal_rule" || this.node.type === "horizontalRule";
  }

  tag() {
    return [
      {
        tag: "hr"
      }
    ];
  }
}
